import { useCallback } from 'react';
import { setSecureValue } from '@helpers';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import { BatchDetailsScreenName } from '@v2/pages/batch/details/navigation/config';
import { BatchDetailsScreen } from '@v2/pages/batch/details/common/enums/batchDetails.enum';
import { LevelSubScreen, Perspective } from '@v2/pages/common/enums';
import { trackSearchResultTapped } from '@services/tracking';

export interface UseManageProductionBatchesParams {
  recentlyViewed: any[];
  setRecentlyViewed: (items: any[]) => void;
  setSelectedNCFile: (v: any) => void;
  setSelectedItem: (id: number | null) => void;
}

export const useManageProductionBatches = ({
  recentlyViewed,
  setRecentlyViewed,
  setSelectedNCFile,
  setSelectedItem,
}: UseManageProductionBatchesParams) => {
  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();

  const open = useCallback(
    (item: any, levelSubScreen: LevelSubScreen = LevelSubScreen.GENERAL) => {
      trackSearchResultTapped('ProductionBatch');
      const exist = recentlyViewed.find((i) => i.itemId === item.productionBatchId && i.itemType === 'ProductionBatch');
      if (!exist) {
        const d = [
          {
            ...item,
            itemType: 'ProductionBatch',
            itemDescription: `${item.ncFileName} ${item.machineShortName}`,
            itemMemo: null,
            itemId: item.productionBatchId,
          },
          ...recentlyViewed,
        ];
        setRecentlyViewed(d);
        setSecureValue('recentlyViewed', JSON.stringify(d));
      }
      setSelectedNCFile({});
      setSelectedItem(item.productionBatchId);
      navigateToMainDetailsScreen({
        mainScreen: BatchDetailsScreenName,
        subScreen: BatchDetailsScreen.BATCH,
        levelSubScreen,
        params: {
          perspective: Perspective.BATCH,
          batchNumber: item.batchNumber,
          batchId: item.productionBatchId,
          ncFileStatus: item.ncFileStatus,
          selectedImageKey: item.imageHash,
          documentId: item.imageDocumentId,
        },
      });
    },
    [recentlyViewed, setRecentlyViewed, setSelectedNCFile, setSelectedItem, navigateToMainDetailsScreen],
  );

  return { open };
};
